var render = function render(){var _vm=this,_c=_vm._self._c;return _c('eden-information-card',{attrs:{"title":'Business Information'}},[_c('template',{slot:"content"},[_c('customer-information',{attrs:{"information":_vm.information}})],1)],2)
}
var staticRenderFns = []

export { render, staticRenderFns }